const { application } = window;

export interface IServerOption {
    name: string;
    serviceId: string;
}

const options: {
    test: IServerOption[];
    live: IServerOption[];
} = {
    test: [{ name: 'us-GM', serviceId: '1049716779' }],
    live: [
        { name: 'North America', serviceId: '1049719851' },
        { name: 'Europe', serviceId: '1048671275' },
    ],
};

export const serverOptions = application.params.environment === 'live' ? options.live : options.test;
